export function unwrapDictData(res) {
  const body = res && res.data !== undefined ? res.data : res;
  return body && body.data !== undefined ? body.data : body;
}

export function unwrapDictList(res) {
  const data = unwrapDictData(res);
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.records)) return data.records;

  return [];
}

export function isProduceDictUrl(url) {
  return typeof url === 'string' && url.indexOf('/api/produce/') === 0;
}

export function produceDictFormatter(res) {
  return unwrapDictList(res);
}

export function applyProduceDictFormatter(column) {
  if (!column || column.dicFormatter || !isProduceDictUrl(column.dicUrl)) return;
  column.dicFormatter = produceDictFormatter;
}

export function applyProduceDictFormatters(columns) {
  if (!Array.isArray(columns)) return;
  columns.forEach((column) => {
    applyProduceDictFormatter(column);
    if (Array.isArray(column.column)) {
      applyProduceDictFormatters(column.column);
    }
    if (Array.isArray(column.children)) {
      applyProduceDictFormatters(column.children);
    }
  });
}
